import { Guid } from "guid-typescript";
import { DeliveryStatusDetail, DeliveryStatus } from "interfaces";
import { StatusTypes } from "components/DeliveryStatusDashboard/Constants";

/**
 * @function
 * @description - Add unique key for delivery status details array
 * @param deliveryStatusDetails status details array
 * @returns List of status details with unique key
 */
export const formatStatusDetails = (
  deliveryStatusDetails: Array<DeliveryStatusDetail>
) => {
  try {
    if (Array.isArray(deliveryStatusDetails)) {
      return deliveryStatusDetails.map((details) => ({
        ...details,
        key: Guid.create().toString(),
      }));
    } else {
      return [];
    }
  } catch (e) {
    return [];
  }
};

/**
 * @function
 * @description - Updates error state if there's any difference between column sum.
 * @param deliveryStatusList status list array
 * @param statusType selected tab
 * @returns List of status with error state
 */
export const formatStatusList = (
  deliveryStatusList: Array<DeliveryStatus>,
  statusType: StatusTypes
) => {
  try {
    if (Array.isArray(deliveryStatusList)) {
      return deliveryStatusList.map((status) => {
        let {
          hangingOnPending = 0,
          failedToGenerate = 0,
          successfullyGenerated = 0,
          orderedToGenerate = 0,
          retainedPDF = 0,
          notPicked = 0,
          alreadyPicked = 0,
          notPrint = 0,
          printConfirmed = 0,
        } = status;

        const totalOrderedActivities = hangingOnPending + failedToGenerate + successfullyGenerated; 
        const totalSentToMercuryActivities = notPrint + printConfirmed;
        const totalOrderedActivitiesSMSAndEmail = failedToGenerate + successfullyGenerated;

        let isError = false;

        if (statusType == StatusTypes.PRINT || statusType == StatusTypes.EHF) {
          // Skip pdf in EHF tab because There is no pdf column in EHF.
          retainedPDF = statusType == StatusTypes.EHF ? 0 : retainedPDF;
          const totalGeneratedActivities = retainedPDF + notPicked + alreadyPicked;

          if (totalOrderedActivities != orderedToGenerate) {
            // Generation Pending + Generation Failed + Generated = Activity Ordered
            isError = true;
          } else if (totalGeneratedActivities != successfullyGenerated) {
            // Manual Printing Documents (PDF) + Not Printing Documents + Sent to Mercurry = Generated
            isError = true;
          } else if (totalSentToMercuryActivities != alreadyPicked) {
            // Printing Failed at Mercury + Printed at Mercurry = Sent to Mercury
            isError = true;
          } else {
            isError = false;
          }
        } else {
          // Generation Failed + Generated = Activity Ordered
          isError = totalOrderedActivitiesSMSAndEmail != orderedToGenerate;
        }

        return {
          ...status,
          isError,
        };
      });
    } else {
      return [];
    }
  } catch (e) {
    return deliveryStatusList;
  }
};
